// Hook centralizando derivação de dados do PersonCard
import { useMemo } from 'react';

import { buildCanonicalAgenda } from '../../../helpers/person/agenda';

export function usePersonCard(person, intl) {
  return useMemo(() => {
    if (!person) return { primary: null, secondary: [], hasDocuments: false };
    const { primary, secondary } = buildCanonicalAgenda(person, intl);
    const hasDocuments = secondary.length > 0 || !!person?.file;
    const id = person?.UID || person?.id || person?.['@id']?.split('/').pop();
    const headingId = id ? `person-${id}-heading` : undefined;
    return { primary, secondary, hasDocuments, id, headingId };
  }, [person, intl]);
}
